import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/navbar';
import About from '../homeComponents/about';
import BannerNew from '../homeComponents/bannerNew';
import Cards from '../homeComponents/cards';
import Choose from '../homeComponents/choose';
import Contact from '../homeComponents/contact';
import ContactDetilas from '../homeComponents/contactDetilas';
import Footer from '../homeComponents/footer';
import Services from '../homeComponents/service';
import ServiceContent from '../homeComponents/serviceContent';
import Story from '../homeComponents/story';
import Testimonials from '../homeComponents/testimonials';
import TestimonialContents from '../homeComponents/testimonialContents';
import Loader from '../loader';
import TopBanner from '../components/topBanner';

const Home = () => {
  const [bannerHeight, setBannerHeight] = useState(0);
  const [landingPageData, setLandingPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();

  // Use environment variable with fallback
  const API_URL = process.env.REACT_APP_API_URL || '';

  useEffect(() => {
    if (location.state?.scrollToAbout) {
      const aboutSection = document.getElementById("about-us");
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    const fetchLandingPage = async () => {
      try {
        const response = await fetch(`${API_URL}/api/landing-page`);
        
        // Check response status
        if (!response.ok) {
          throw new Error(`Server responded with status: ${response.status}`);
        }
        
        // Check content type
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          const text = await response.text();
          throw new Error(`Expected JSON but got: ${contentType || 'unknown'}`);
        }
        
        const data = await response.json();
        // console.log("Landing page data fetched:", data);
        setLandingPageData(data);
      } catch (err) {
        setError(`Failed to load content: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchLandingPage();
  }, [API_URL]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className='h-full w-full font-clash'>
      <Helmet>
        <title>Carvetpro</title>
        <meta
          name="keywords"
          content="Pdi, Bengaluru, Bangalore, Kardo, Inspection, Ze, Pre delivery, Services, Car, Cars, Vaidya, BHP, Team, CID, Expert, In, Best, 24, BOSS, Dail, Just, New car, Checklist, Detailed, Report, Inspect, Reliable, Blog, Used car inspection, Buying a new car"
        />
        <meta
          name="description"
          content="Explore our reliable pre-delivery inspection services for new and used cars. Detailed reports, expert insights, and the best service in Bangalore and beyond."
        />
      </Helmet>
      <TopBanner setBannerHeight={setBannerHeight} />
      <Navbar offset={bannerHeight} />
      
      {landingPageData && (
        <>
          <BannerNew slides={landingPageData.bannerSlides} />
          <Services header={landingPageData.services?.header} />
          <ServiceContent services={landingPageData.services?.serviceItems} />
          <Choose header={landingPageData.whyChooseUs?.header} />
          <Cards featureCards={landingPageData.whyChooseUs?.featureCards} />
          <About header={landingPageData.aboutUs?.header} />
          <Story storySection={landingPageData.aboutUs?.storySection} />
          <Testimonials header={landingPageData.testimonials?.header} />
          <TestimonialContents testimonialCards={landingPageData.testimonials?.testimonialCards} />
          <Contact header={landingPageData.contactUs?.header} />
          <ContactDetilas />
          <Footer footer={landingPageData.footer} />
        </>
      )}
    </div>
  );
};

export default Home;